export const LOADING_STATE = {
  FAILED: 'failed',
  LOADING: 'loading',
  NOT_LOADED: 'not-loaded',
  OUTDATED: 'outdated',
  SUCCEEDED: 'succeeded',
} as const;
